<template>
  <div class="pages" v-cloak>
    <headerView :show-bg="true"></headerView>

    <div class="header-top" :class="'header-top-' + headerItem.pageType" v-if="headerItem.imgUrl">
      <div class="header-top-img">
        <img class="img" :src="headerItem.imgUrl" />
      </div>
      <div class="header-top-txt">
        <p class="title">{{ headerItem.navigationName }}</p>
        <p class="subTitle">{{ headersubTitle || "" }}</p>
      </div>
    </div>
    <summaryBriefModule></summaryBriefModule>

    <!-- <div class="topseat">
      <i class="el-icon-location-outline"></i>
      <span>{{ $t("top_txt_seat") }}</span>
      <span v-for="(item, index) in seatList" :key="index">
        <i class="el-icon-arrow-right"></i>
        <span>{{ item }}</span>
      </span>
    </div> -->
    <div class="w1280 pageContent">
      <div v-if="spuData && spuData.spu">
        <div class="goods-cat-top-head">
          <h3 class="goods-cat-top-title">产品系列</h3>
          <p class="goods-cat-top-subtitle">创新实力产品，品牌成就未来</p>
        </div>
        <div class="row container">
          <div class="recommend-list">
            <div class="recommend-item" v-for="(item, index) in categoryList"
              :class="{ 'active': spuData.spu.spuId == item.spuId }" @click="jumpDetail(item.spuId)">
              <div class="recommend-item_text">{{ item.tag }}</div>
            </div>
          </div>

          <div id="goodsZoom">
            <div id="zoomTop">
              <!--        小图框-->
              <div id="smallPic" @mouseover="handlerMouseOver" @mouseleave="handlerMouseLeave"
                @mousemove="handlerMouseMove">
                <img :src="smallImgSrc" />
                <!-- 蒙版元素-->
                <div id="mask" v-show="show"></div>
              </div>
              <!-- 大图框-->
              <div id="bigPic" v-show="show">
                <img :src="bigImgSrc" id="bigImg" />
              </div>
            </div>

            <div id="zoomBottom" class="clearfix">
              <a href="javascript:;" class="prev" @click="handlerPrev">
                <i class="el-icon-arrow-left"></i>
              </a>
              <div id="picList">
                <ul>
                  <li v-for="(item, index) in spuData.BannerImgList" @click="thumbnailClick(item, index)" :key="index"
                    :class="{ active: index == imgActive }">
                    <img :src="item.masterUrl" />
                  </li>
                </ul>
              </div>
              <a href="javascript:;" class="next" @click="handlerNext">
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
          </div>

          <div class="goodsWrods">
            <div>
              <div class="goodsName">{{ spuData.spu.name }}</div>
              <div class="goodsRefer">
                <!-- {{ spuData.spu.desc }} -->
                <pre v-html="spuData.spu.desc" v-if="spuData.spu.desc"></pre>
              </div>
              <div class="rights-list">
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-1.png" />
                  </div>
                  <span>高清透镜</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-2.png" />
                  </div>
                  <span>切线清晰</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-3.png" />
                  </div>
                  <span>智能散热</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-4.png" />
                  </div>
                  <span>稳定耐用</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-5.png" />
                  </div>
                  <span>一线品牌</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-6.png" />
                  </div>
                  <span>只换不修</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-7.png" />
                  </div>
                  <span>全国联保</span>
                </div>
                <div class="rights-item">
                  <div class="imgView">
                    <img src="@/assets/images/goods-8.png" />
                  </div>
                  <span>百万保险</span>
                </div>
              </div>

              <div class="parameter-list" v-if="spuData.spu.parameterTable && spuData.spu.parameterTable.length > 0">
                <div class="parameter-item" v-for="item in spuData.spu.parameterTable">
                  <div class="label">{{ item.label }}</div>
                  <div class="value">{{ item.value || "--" }}</div>
                </div>

              </div>

            </div>
            <div class="row oper">
              <button class="btn">{{ $t("pay_txt") }}</button>
              <a :href="spuData.spu.docFileUrl" :download="spuData.spu.docFileName" class=" pointer down c-black btn2"
                v-if="spuData.spu.docFileUrl">
                <!-- <img class="img" src="@/assets/images/download.png" /> -->
                <span>{{ $t("manual_txt") }}</span>
              </a>


              <el-popover placement="bottom" width="180" trigger="click"
                v-if="spuData.spu.carModels && spuData.spu.carModels.length">
                <div class="car-list">
                  <div class="title">适配车型</div>
                  <ul class="ul-list">
                    <li v-for="item in spuData.spu.carModels">{{ item }}</li>
                  </ul>
                </div>

                <el-button slot="reference" class="btn2">查看适配车型</el-button>
              </el-popover>


              <!-- <button class="btn2">查看适配车型</button> -->
            </div>


          </div>
        </div>

        <div class="goodsDetail">
          <div class="rowCenter title">{{ $t("goods_detail_1") }}</div>
          <!-- <el-table v-if="
          spuData.spu.parameterTable && spuData.spu.parameterTable.length > 0
        " :data="spuData.spu.parameterTable" border class="tm-table-body" style="width: 100%">
          <el-table-column prop="label" :label="$t('goods_detail_2')"></el-table-column>
          <el-table-column prop="value" :label="$t('goods_detail_3')"></el-table-column>
        </el-table> -->
          <div style="margin-top: 10px">
            <pre v-html="spuData.spu.detail" v-if="spuData.spu.detail"></pre>
          </div>

          <div class="column items-center detail" style="margin-top: 10px">
            <img :src="item.masterUrl" style="width: 100%; display: block"
              v-for="(item, index) in spuData.DetailImgList" :key="index" />
          </div>
        </div>
      </div>
    </div>


    <footView></footView>
  </div>
</template>

<script>
import { getSpuDetail, getCategorySpu, getSpuList } from "@/request/api";
import { mapGetters } from "vuex";
import summaryBriefModule from "@/components/Custom/SummaryBrief";
export default {
  name: "goods-magnifier-zoom",
  components: {},
  data() {
    return {
      headerItem: "",
      headersubTitle: "",
      show: false, //是否显示
      bigImgSrc: "",
      smallImgSrc: "",
      imgActive: 0,
      start: 0,
      prevShow: false,
      spuData: {},
      seatList: [],
      categoryList: [],

    };
  },
  components: { summaryBriefModule },
  computed: {
    ...mapGetters(["categoryObj", "navigationList"]),
  },

  watch: {
    'navigationList': {
      handler(newVal) {
        if (newVal) {
          let hitem = newVal.find(item => {
            if (item.pageType === 'class') {
              return true
            }
            return false;
          }) || {
            imgUrl: "https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202608/124233558064.jpg",
            navigationName: "产品中心",
            pageType: "class",
          };
          this.headerItem = hitem;
        }
      },
      immediate: true,
      deep: true
    },
    categoryObj() {
      this.getSeat();
    },

    $route(to, from) {
      this.$route.go();
    }
  },


  created() {
    if (this.$route.query) {
      this.$route.query.id && this.fetchData(this.$route.query.id);
    }
  },
  methods: {


    fetchData(id) {
      let that = this;
      that.stateSche = 1;
      getSpuDetail("spuId=" + id).then((res) => {
        if (res.code == 200 && res.data) {
          let data = res.data;
          let spuImageList = data.spuImageList || [];
          data.BannerImgList = [];
          data.DetailImgList = [];
          spuImageList.forEach((item) => {
            item.isMain == 1
              ? data.BannerImgList.push(item)
              : data.DetailImgList.push(item);
          });

          data.spu.parameterTable = data.spu.parameterTable
            ? JSON.parse(data.spu.parameterTable)
            : [];

          this.spuData = data;
          this.getSeat();
          this.bigImgSrc = res.data.sku.masterUrl;
          this.smallImgSrc = res.data.sku.masterUrl;
          this.prevShow = data.BannerImgList.length > 4 ? true : false;


          if (res.data.industries && res.data.industries[0]) {
            let subTitle = res.data.industries.map(child => child.industryName);

            this.headersubTitle = subTitle.join("/") + "分类";
          }
          this.queryCategorySpu()

          that.stateSche = 0;
        } else {
          that.stateSche = 2;
          that.$message({
            type: "error",
            message: res.message ? res.message : "商品查无数据！",
          });
        }
      });
    },

    queryCategorySpu() {
      let that = this;
      if (!this.spuData.spu || !this.spuData.spu.category) {
        return
      }
      let idList = this.spuData.spu.category;
      idList = idList.split("/");

      getCategorySpu("categoryId=" + idList[idList.length - 1]).then((res) => {
        if (res.code == 200) {
          if (res.data != null && res.data.length > 0) {
            let data = res.data || [];

            that.categoryList = data.map(item => {
              item.tag = item.name.slice(0, 4)
              return item
            });

          }
        }
      });


      // getSpuList({
      //       pageParm: {
      //         page: 1,
      //         limit: 8,
      //         keyword: "",
      //         field: "",
      //         sort: 0
      //       },
      //       categoryId:idList[idList.length-1],
      //     }).then((res) => {
      //       if (res.code == 200) {
      //         if (res.data != null && res.data.length > 0) {
      //           let data=res.data||[];

      //           that.categoryList = data.map(item=>{
      //             item.tag=item.name.slice(0,3)
      //             return item
      //           });

      //         } 
      //       }
      //     });


    },

    jumpDetail(id) {

      this.$router.replace("/goods/detail?id=" + id)
    },


    // 8899
    getSeat() {
      let that = this;
      let categoryObj = this.categoryObj || {};
      let spuData = this.spuData;
      let objkey = Object.keys(categoryObj);
      if (spuData.spu && objkey && objkey.length) {
        let id = spuData.spu.category.split("/");
        let seatList = [];
        id.forEach((item) => {
          seatList.push(categoryObj[item]?.categoryName);
        });
        that.seatList = seatList;
      }
      // let that = this;
      // id = id.split("/");
      // let fristID = id[0];
      // let lastID = id[1];
      // getCategoryList().then((res) => {
      //   let seatList = [];
      //   let level_1 = res.data.find((item) => fristID == item.id);
      //   seatList.push(level_1.categoryName);

      //   if (
      //     level_1.subcategories &&
      //     level_1.subcategories.length > 0 &&
      //     lastID
      //   ) {
      //     let lalevel_2 = level_1.subcategories.find(
      //       (item) => lastID == item.id
      //     );

      //     lalevel_2 && seatList.push(lalevel_2.categoryName);
      //   }

      //   that.seatList = seatList;
      // });
    },

    //鼠标移入事件
    handlerMouseOver() {
      this.show = true;
    },
    //鼠标移出事件
    handlerMouseLeave() {
      this.show = false;
    },
    //鼠标移动事件
    handlerMouseMove(data) {
      const smallPic = document.getElementById("smallPic");
      const bigPic = document.getElementById("bigPic");
      const bigImg = document.getElementById("bigImg");
      const zoomTop = document.getElementById("zoomTop");
      const mask = document.getElementById("mask");
      //蒙版边界设置
      let left =
        data.clientX -
        smallPic.getBoundingClientRect().left -
        mask.offsetWidth / 2;
      let top =
        data.clientY -
        smallPic.getBoundingClientRect().top -
        mask.offsetHeight / 2;
      //边界判断
      if (left < 0) {
        left = 0;
      } else if (left > smallPic.clientWidth - mask.offsetWidth) {
        left = smallPic.clientWidth - mask.offsetWidth;
      }
      if (top < -1) {
        top = -1;
      } else if (top > smallPic.clientHeight - mask.offsetHeight) {
        top = smallPic.clientHeight - mask.offsetHeight;
      }
      mask.style.left = left + "px";
      mask.style.top = top + "px";
      let scale =
        (smallPic.clientWidth - mask.offsetWidth) /
        (bigImg.offsetWidth - bigPic.clientWidth);

      bigImg.style.left = -left / scale + "px";
      bigImg.style.top = -top / scale + "px";
    },
    //缩略图点击效果
    thumbnailClick(data, index) {
      this.bigImgSrc = data.masterUrl;
      this.smallImgSrc = data.masterUrl;
      this.imgActive = index;
    },
    //点击前一个
    handlerPrev() {
      if (!this.prevShow) {
        return;
      }
      let ul = document.querySelector("#goodsZoom #zoomBottom #picList ul");
      let liNodes = document.querySelectorAll(
        "#goodsZoom #zoomBottom #picList li"
      );
      if (liNodes.length === 0) {
        return;
      }
      //步长
      let step = (liNodes[0].offsetWidth + 20) * 2;
      this.start -= step;
      if (this.start < 0) {
        this.start = 0;
      }
      ul.style.left = -this.start + "px";
    },
    //点击下一个
    handlerNext() {
      if (!this.prevShow) {
        return;
      }
      let ul = document.querySelector("#goodsZoom #zoomBottom #picList ul");
      let liNodes = document.querySelectorAll(
        "#goodsZoom #zoomBottom #picList li"
      );
      if (liNodes.length === 0) {
        return;
      }
      //步长
      let step = (liNodes[0].offsetWidth + 20) * 2;
      //总体运动的距离值 = ul的宽度 - div框的宽度 = (图片的总数 - div中显示的数量) * （li的宽度 + 20）
      let endPosition = (liNodes.length - 5) * (liNodes[0].offsetWidth + 20);
      this.start += step;
      if (this.start > endPosition) {
        this.start = endPosition;
      }
      ul.style.left = -this.start + "px";
    },
  },


};
</script>

<style scoped lang="scss">
.pageContent {
  min-height: 45vh;
}

.topseat {
  background-color: #666;
  color: #fff;
  padding: 18px 0 18px 24px;
  margin-bottom: 50px;

  .el-icon-location-outline {
    margin-right: 4px;
  }

  .el-icon-arrow-right {
    margin: 0 10px;
  }
}


.goods-cat-top-head {
  margin: 16px 16px 36px;
}

.goods-cat-top-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  margin: 0 0 5px;
  // padding-left: 12px;
  // border-left: 4px solid #e60012;
}

.goods-cat-top-subtitle {
  font-size: 14px;
  color: var(--main-color);
  line-height: 1.4;
  margin: 0;
}


.container {
  margin: 5px 0 15px;
  overflow: hidden;

  #goodsZoom {
    width: 400px;
    text-align: center;
    margin-right: 60px;

    #zoomTop {
      width: 400px;
      position: relative;

      #smallPic {
        width: 398px;
        height: 398px;
        border: 1px solid #dfdfdf;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        #mask {
          width: 200px;
          height: 200px;
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid #ddd;
          position: absolute;
          left: 0px;
          top: -1px;
        }
      }

      #bigPic {
        margin-left: 4px;
        width: 400px;
        height: 400px;
        border: 1px solid #ddd;
        left: 400px;
        top: 0px;
        position: absolute;
        overflow: hidden;

        #bigImg {
          width: 1000px;
          height: 1000px;
          position: absolute;
          left: 0px;
          top: 0px;
        }
      }
    }

    #zoomBottom {
      margin-top: 5px;
      display: inline-block;

      a {
        float: left;
        text-decoration: none;
        color: #888;
        font-weight: 700;
        font-size: 24px;

        &:first-child {
          margin-right: 4px;
          margin-top: 18px;
        }

        .el-icon-caret-left {
          margin: 2px 2px 2px 0;
        }
      }

      .next {
        margin-top: 18px;

        .el-icon-caret-right {
          margin: 2px;
        }
      }

      #picList {
        width: 340px;
        height: 60px;
        float: left;
        overflow: hidden;
        position: relative;

        ul {
          white-space: nowrap;
          font-size: 0px;
          position: absolute;
          left: 0px;
          transition: 0.5s;

          li {
            width: 60px;
            height: 60px;
            padding: 2px;
            margin-right: 6px;
            display: inline-block;
            border: solid 1px transparent;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .active {
            border-color: #ff0000;
          }
        }
      }
    }
  }

  .goodsWrods {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;

    .goodsName {
      color: #1788d8;
      font-size: 20px;
      margin-bottom: 18px;
    }

    .goodsRefer {
      font-size: 15px;
      margin-bottom: 18px;
    }

    .rights-list {
      display: flex;
      flex-wrap: wrap;
      font-size: 13px;
      margin-bottom: 10px;

      .rights-item {
        display: flex;
        align-items: center;
        width: 25%;
        margin-bottom: 10px;
      }

      .imgView {
        background-color: #dedede;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;

        img {
          width: 32px;
          height: auto;
        }
      }
    }


    .parameter-list {
      display: flex;
      flex-wrap: wrap;
      font-size: 13px;

      .parameter-item {
        width: 25%;
        margin-bottom: 10px;
      }

      .label {
        color: #888;
      }

      .value {
        margin-top: 6px;
        color: var(--main-color);
      }
    }


    .btn {
      color: #fff;
      background-color: var(--main-color);
      border: none;
      line-height: 42px;
      width: 130px;
      border-radius: 10px;
      font-size: 14px;
    }

    .btn2 {
      color: var(--main-color);
      border: solid 1px var(--main-color);
      line-height: 42px;
      width: 130px;
      border-radius: 10px;
      text-align: center;
      margin-left: 18px;
      font-size: 14px;
      background-color: #fff;
      cursor: pointer;
      padding: 0;

    }

    .img {
      width: 28px;
      height: 28px;
      margin-right: 12px;
    }
  }
}

.goodsDetail {
  .title {
    font-size: 24px;
    justify-content: center;
    margin: 80px 0 30px;
  }

  .title::after,
  .title::before {
    content: "";
    display: inline-block;
    width: 60px;
    height: 3px;
    border-radius: 3px;
    margin: 0 8px;
    background-color: #333;
  }
}

.recommend-list {
  margin-right: 15px;
  max-height: 398px;
  flex: none;
  overflow-y: auto;

  .recommend-item {
    padding-right: 15px;
    border-right: solid 3px transparent;
    cursor: pointer;


  }

  .recommend-item+.recommend-item {
    margin-top: 10px;
  }

  .recommend-item_text {
    border-radius: 6px;
    background-color: #fff;
    text-align: center;
    padding: 4px;
    line-height: 26px;
    font-size: 14px;
    width: 100px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
  }

  .active {
    border-right-color: var(--main-color);
  }

  .active .recommend-item_text {
    color: #fff;
    background-color: var(--main-color);
  }
}

.car-list {
  .title {
    color: var(--main-color);
    line-height: 30px;
    margin-bottom: 5px;
  }

  .ul-list {
    max-height: 300px;
    overflow-y: auto;

  }

  li {
    padding: 5px 0;
  }
}



@media (max-width: 750px) {
  .topseat {
    margin-bottom: 20px;
  }

  .container {
    flex-direction: column;
    align-items: center;
    padding: 0 30px;

    #goodsZoom {
      margin-right: 0;
      width: 100%;

      #zoomTop {
        width: 100%;
      }

      #smallPic {
        width: 100% !important;
        height: auto !important;
      }
    }

    #mask,
    #bigPic {
      visibility: hidden;
    }
  }

  .oper {
    margin-top: 13px;
  }

  .recommend-list {
    display: none;
  }
}
</style>